import request from './service.js'
// const baseUrl = 'https://cmp-booklib-api.work.zving.com/front';
const baseUrl = 'https://serve.cmpreading.com/front';
export default {

    //首页-是否显示主题书单、闲翻书、视频荐书
    cropShow(params) { 
        return request({
        url: `${baseUrl}/permit/crop?token=${params}`,
        method: 'GET',
        })
    },
    //首页-主题书单、主题书单-所有书单
    themeList(params) { 
        return request({
        url: `${baseUrl}/permit/bookList/themeList`,
        method: 'GET',
        params
        })
    },
    // 首页-闲翻书、闲翻书列表页
    leisureList(params) { 
        return request({
        url: `${baseUrl}/permit/leisure/list`,
        method: 'GET',
        params
        })
    },
    //主题书单-推荐书单
    themeRecommend(params) { 
        return request({
        url: `${baseUrl}/permit/bookList/themeList/recommend`,
        method: 'GET',
        params
        })
    },
    //书单详情-右侧聚合数量
    themeInfoAggRes(params) { 
        return request({
        url: `${baseUrl}/bookShelf/themeInfoAggRes`,
        method: 'GET',
        params
        })
    },
    //书单详情-左侧资源数据
    themeListInfo(params) { 
        return request({
        url: `${baseUrl}/bookShelf/themeListInfo`,
        method: 'GET',
        params
        })
    },
    //书单详情-热门专题
    themeHotTopic(params) { 
        return request({
        url: `${baseUrl}/permit/bookList/themeList/visitOrderList`,
        method: 'GET',
        params
        })
    },
    //分类-分类菜单
    classifyAgg(params) { 
        return request({
        url: `${baseUrl}/permit/classify/aggs?token=${params}`,
        method: 'GET',
        })
    },
    //分类-分类列表
    classifyList(params,token) { 
        return request({
        url: `${baseUrl}/permit/classify/list?token=${token}`,
        method: 'GET',
        params
        })
    },
    //学习报告-总数
    getRecordTotalPC(params) { 
        return request({
        url: `${baseUrl}/member/readResource/getRecordTotalPC`,
        method: 'GET',
        params
        })
    },
    //学习报告-列表
    getRecordList(params) { 
        return request({
        url: `${baseUrl}/member/readResource/getRecordList`,
        method: 'GET',
        params
        })
    },
    ///* 书架书单列表 */
    fetchShelfList(params) { 
        return request({
        url: `${baseUrl}/bookShelf/shelfList`,
        method: 'GET',
        params
        })
    },
    /* 批量移除书架-书单 */
    fetchBatchDelShelf(params) { 
        return request({
        url: `${baseUrl}/bookShelf/batchDelShelf`,
        method: 'DELETE',
        params
        })
    },
    /* 加入书架-书单 */
    fetchaddShelf(params) { 
        return request({
        url: `${baseUrl}/bookShelf/addShelf`,
        method: 'POST',
        params
        })
    },
    /* 加入书架-书单 */
    fetchDelShelf(params) { 
        return request({
        url: `${baseUrl}/bookShelf/delShelf`,
        method: 'DElETE',
        params
        })
    },
    /* 分类列表 */
    fetchClassify(code) { 
        return request({
        url: `${baseUrl}/permit/classify?code=${code}`,
        method: 'GET',
        })
    },
    /* 闲翻书投票 */
    fetchLeisureVote(params) { 
        return request({
        url: `${baseUrl}/permit/leisure/vote`,
        method: 'POST',
        params
        })
    },
    /* 闲翻书详情 */
    fetchLeisureDetail(ID) { 
        return request({
        url: `${baseUrl}/permit/leisure/${ID}`,
        method: 'GET',
        })
    },
    /* 闲翻书-推荐书单 */
    fetchLeisureDetailBook(ID, params) { 
        return request({
        url: `${baseUrl}/permit/leisure/recommendList/${ID}`,
        method: 'GET',
        params
        })
    },
    /* 图书阅读量 */
    fetchBookCount(ID) { 
        return request({
        url: `${baseUrl}/permit/accessRecords/count?bookID=${ID}`,
        method: 'GET',
        })
    },
    /* 图书阅读信息 */
    fetchAccessRecords(ID) { 
        return request({
        url: `${baseUrl}/permit/accessRecords/info?bookID=${ID}`,
        method: 'GET',
        })
    },
    /* 电子书目录 */
    fetchEpubDir(ID) { 
        return request({
        url: `${baseUrl}/permit/book/${ID}/getEpubDir`,
        method: 'GET',
        })
    },
    /* 电子书目录 */
    login(token) { 
        return request({
        url: `${baseUrl}/permit/login?token=${token}`,
        method: 'GET',
        })
    },
   









    
}

